import { render } from "./TipTapToolbar.vue?vue&type=template&id=d328c3e8"
import script from "./TipTapToolbar.vue?vue&type=script&lang=js"
export * from "./TipTapToolbar.vue?vue&type=script&lang=js"

import "./TipTapToolbar.vue?vue&type=style&index=0&id=d328c3e8&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__